import { Box, Fade } from "@mui/material";
import { ReactNode } from "react";
import theme from "@/config/mui/theme";

type ExpandableCardThumbnailProps = {
  thumbnail: (thumbnailSize: number) => ReactNode;
  thumbnailHeight: number;
  expansionHeight: number;
  isFocused: boolean;
};

const THUMBNAIL_PADDING = 8; // px

export default function ExpandableCardThumbnail({
  thumbnail,
  thumbnailHeight,
  expansionHeight,
  isFocused,
}: ExpandableCardThumbnailProps) {
  return (
    <Box
      sx={{
        maxHeight: thumbnailHeight,
        padding: "8px 8px 0 8px",
        marginBottom: isFocused ? `-${expansionHeight}px` : 0,
        transition: theme.transitions.create(["margin-bottom"], {
          duration: theme.transitions.duration.standard,
        }),
      }}
    >
      {thumbnail(thumbnailHeight - THUMBNAIL_PADDING)}
      <Fade in={isFocused}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "#13131680",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
      </Fade>
    </Box>
  );
}
